import React from 'react';
import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';

const RouteError: React.FC = () => {
  const error = useRouteError();
  let errorMessage: string;
  let errorStatus: number | undefined;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || 'An unexpected error occurred.';
    errorStatus = error.status;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else {
    errorMessage = 'An unknown error occurred.';
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-brand-background text-brand-text p-4">
      <div className="text-center bg-brand-surface p-8 rounded-lg shadow-xl max-w-lg w-full border border-brand-muted">
        <h1 className="font-heading text-6xl font-bold text-brand-primary mb-2">
          {errorStatus || 'Error'}
        </h1>
        <p className="font-heading text-2xl font-semibold text-brand-heading mb-4">
          Oops! Something went wrong.
        </p>
        <p className="text-lg text-brand-text-muted mb-8">{errorMessage}</p>
        <Link
          to="/"
          className="font-heading px-6 py-3 bg-brand-primary text-white font-bold rounded-lg hover:bg-brand-primary-hover transition-colors duration-300"
        >
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default RouteError;
